import {
  getLastAds,
  setLastAds,
  getAndroidDeviceInfo,
  getWxPkgVersion,
  getQQPkgVersion,
  getLoginData,
  fetch,
  getHost,
  getQueryObj,
  encodeQueryObj,
} from './utils';
import Log from '../log';
import { throttle } from '@tencent/rich_utils/lib/browser.utils';
import { openMotivationVideo as nfa, IenvType } from '@tencent/nfa_exciation_video_h5_sdk';
// import { SetAmsRewardVideoCallbackParam } from '@tencent/nfa_exciation_video_h5_sdk/lib/type/index';
import qbjsapi from '../../qb/jsapi';
import sendBoss from '../../base/sendBoss';

const guid = '';
let mStatUrl = {};
let exposureUrl = ''; // 中台曝光url

const makeAmsParams = (data) => {
  try {
    const mAdsCommodityInfoExt = data?.stAdsCommodityInfo?.mAdsCommodityInfoExt || {};
    const { ams_sdk_rsp: amsSdkRsp = '{}' } = mAdsCommodityInfoExt;
    // 解析gt参数（ams曝光参数）
    const queryObj = getQueryObj(data.sAdShowUrl, '?');
    delete queryObj.gt;
    mStatUrl = data?.mStatUrl || {};
    exposureUrl = `${data.sAdShowUrl.split('?')[0]}?${encodeQueryObj(queryObj)}`;

    return {
      posid: mAdsCommodityInfoExt.report_ams_pos_id || '',
      amsData: JSON.parse(amsSdkRsp),
    };
  } catch (err) {
    Log.getInstance().logErr(err);
    return {};
  }
};

const getSdkInfo = () => new Promise((resolve) => {
  if (window?.browser?.ad?.getADDeviceInfo) {
    window.browser.ad.getADDeviceInfo(
      (res) => {
        if (res.code === 0 || res.code === '0') {
          resolve(res);
        } else {
          resolve(null);
        }
      },
      {
        type: 0,
      },
    );
  } else {
    resolve(null);
  }
});
/**
 * 初始化请求参数
 */
const getParams = async () => {
  try {
    // 通过sdk获取ams广告需要的数据
    const amsSdkInfo = await getSdkInfo();
    Log.getInstance().logInfo(`amsSdkInfo ${JSON.stringify(amsSdkInfo)}`);

    if (amsSdkInfo) {
      const [deviceInfo, wxVersionName = '', qqVersionName = '', loginInfo] = await Promise.all([
        getAndroidDeviceInfo(),
        getWxPkgVersion(),
        getQQPkgVersion(),
        getLoginData(),
      ]);
      const lastAds = getLastAds();
      const { androidId, macAddr, oaid, taid, imei } = deviceInfo;
      const { type, uin } = loginInfo || {};
      const deviceInfoStr = JSON.stringify(amsSdkInfo?.deviceInfo);
      return {
        lastAds,
        supportHttps: location.protocol.indexOf('https') > -1 ? '1' : '0',
        taid,
        oaid,
        imei,
        androidId,
        macAddr,
        wxVersionName,
        qqVersionName,
        type,
        uin,
        amsSdkInfo: deviceInfoStr,
      };
    }
    return {};
  } catch (err) {
    Log.getInstance().logErr(`nfa getparams error: ${err.message}`);
    return {};
  }
};
/**
 * 请求广告
 */
const requestAd = async (initParams) => {
  const params = await getParams();

  if (!params) {
    qbjsapi.toast('获取广告参数失败');
    Log.getInstance().logInfo('获取广告参数失败');
    return;
  }

  const body = {
    ...params,
    ...initParams,
  };

  const rsp = await fetch(`${getHost()}/api/ad/common/motivation`, {
    method: 'POST',
    mode: 'cors',
    body,
  }).catch((e) => {
    Log.getInstance().logErr(e);
  });

  if (rsp && rsp.length > 0) {
    const json = rsp[0];
    const { mAdsCommodityInfoExt } = json.stAdsCommodityInfo;
    let lastAds = '';
    if (mAdsCommodityInfoExt) {
      lastAds = mAdsCommodityInfoExt.last_ads || '';
      lastAds && setLastAds(lastAds);
    }
    const amsParams = makeAmsParams(json);
    return amsParams;
  }
};
/**
 * 设置sdk数据并展示广告
 * @param adData
 * @param callback
 */
const setAndShowInSdk = (adData, callback, params) => {
  if (window?.browser?.ad?.setAmsRewardVideoAD) {
    const sdkData = {
      posId: adData.posid,
      adData: adData.amsData,
      gainRewardTime: adData.gainRewardTime,
    };
    // 观看未满xx秒的左上角文案
    if (params.unmetTipsText) {
      sdkData.unmetTipsText = params.unmetTipsText;
    }
    // 观看已满xx秒的左上角文案
    if (params.hasDoneTipsText) {
      sdkData.hasDoneTipsText = params.hasDoneTipsText;
    }
    // 激励视频关闭对话框文案
    if (params.dialogText) {
      sdkData.dialogText = params.dialogText;
    }
    // 激励视频关闭对话框的确认按钮文案
    if (params.rightButtonText) {
      sdkData.rightButtonText = params.rightButtonText;
    }
    // 激励视频关闭对话框的取消按钮文案
    if (params.leftButtonText) {
      sdkData.leftButtonText = params.leftButtonText;
    }

    const setAMSStartTime = Date.now();

    window.browser.ad.setAmsRewardVideoAD((setRsp) => {
      callback?.(setRsp, adData);

      if (setRsp && (setRsp.code === 0 || setRsp.code === '0')) {
        if (setRsp.data === 'onADLoad') {
          sendBoss('statistics', {
            element_type: 'nfa_sdk_setAmsRewardVideoAD',
            profileid: Date.now() - setAMSStartTime,
          });

          const showAmsRewardVideoADStartTime = Date.now();

          window.browser.ad.showAmsRewardVideoAD(
            () => {
              sendBoss('statistics', {
                element_type: 'nfa_sdk_showAmsRewardVideoAD',
                profileid: Date.now() - showAmsRewardVideoADStartTime,
              });
            },
            {
              posId: adData.posid,
            },
          );
        }
        // 点击上报到中台
        if (setRsp.data === 'onADClick') {
          if (25 in mStatUrl) {
            const {
              25: [commReportUrl],
            } = mStatUrl;
            commReportUrl
              && fetch(`${commReportUrl}&acttype=59`, {
                headers: {
                  'Q-GUID': guid,
                },
              });
          }
        }
        // 曝光上报到中台
        if (setRsp.data === 'onADShow') {
          exposureUrl
            && fetch(`${exposureUrl}`, {
              headers: {
                'Q-GUID': guid,
              },
            });
        }
      }
    }, sdkData);
  }
};

export const init = async (params, callback) => {
  try {
    const reqStartTime = Date.now();
    let amsData = await requestAd(params);
    // 重试一次
    if (!amsData) {
      amsData = await requestAd(params);
    }

    if (!amsData) {
      // 暴露拉取广告失败事件
      callback({
        code: 0,
        data: 'onLoadAdFail',
      });
    }
    const reqEndTime = Date.now();

    sendBoss('statistics', {
      element_type: 'nfa_sdk_req_api',
      profileid: reqEndTime - reqStartTime,
    });
    if (amsData) {
      setAndShowInSdk(amsData, callback, params);
    }
  } catch (error) {
    callback({
      code: 1,
      data: 'onLoadAdFail',
    });
  }
};
/**

 * @param callback 事件的回调(onADLoad,onVideoCached,onADShow,onADExpose,onReward,onVideoComplete,onADClose)
 */
export const initMotivationAd = (params, callback) => {
  init(params, (res) => {
    if (res && (res.code === 0 || res.code === '0') && res.data === 'onReward') {
      // 任务完成上报
      const { businessid } = params;
      if ((window?.browser)?.usercenter?.reportDataToWelfareCenter) {
        (window.browser).usercenter.reportDataToWelfareCenter(
          () => {
            callback(res);
          },
          {
            businessid, // 必填，业务场景
            jsondata: JSON.stringify({
              business: businessid,
              guid,
              type: 0, // 必填 0:次数型，1:持续时长类型
              step: 1, // 必填，次数或时长秒
              time: Date.now(), // 必填 时间戳
              // contentId: adData.posid || '',// 选填
              // vimewTime: //选填 页面停留时长
            }),
          },
        );
      }
    } else {
      callback(res);
    }
  });
};

/** 打开激励视频 */
export const openMotivationVideo = (
  guid,
  params,
  succCallback,
  options,
) => {
  const req = {
    posId: params.posId,
    appId: params.appId,
    env: IenvType.prod,
    // TODO:
    // env: getEnvIsTest() ? IenvType.gray : IenvType.prod,
    gainRewardTime: 15,
  };

  console.log(`开始唤起激励视频, bid: ${params.businessId}; appId: ${params.appId}; posId: ${params.posId};`);
  console.log('激励视频传参', req);
  // 调起激励视频做防抖处理
  throttle(() => {
    nfa(
      req,
      (res) => {
        Log.getInstance().logInfo(`openMotivationVideo successCB; bid: ${params.businessId}; appId: ${params.appId}; posId: ${
          params.posId
        }; guid: ${guid}; res: ${JSON.stringify(res)}`);

        console.log(`openMotivationVideo successCB; bid: ${params.businessId}; appId: ${params.appId}; posId: ${
          params.posId
        }; guid: ${guid}; res: ${JSON.stringify(res)}`);
        if (window?.browser?.usercenter?.reportDataToWelfareCenter) {
          window.browser.usercenter.reportDataToWelfareCenter(
            (CB) => {
              // eslint-disable-next-line no-console
              console.log('终端上报回包', CB);
              Log.getInstance().logInfo(`reportDataToWelfareCenter successCB; res: ${JSON.stringify(CB)}bid: ${params.businessId}; appId: ${
                params.appId
              }; posId: ${params.posId}; guid: ${guid}`,);
              succCallback?.(res);
            },
            {
              businessid: params.businessId, // 必填，业务场景
              jsondata: JSON.stringify({
                business: params.businessId,
                guid,
                type: 0, // 必填 0:次数型，1:持续时长类型
                step: 1, // 必填，次数或时长秒
                time: Date.now(), // 必填 时间戳
                // contentId: adData.posid || '',// 选填
                // vimewTime: //选填 页面停留时长
              }),
            },
          );
        } else {
          succCallback?.(res);
        }
      },
      {
        onError: options?.onError,
        onLoadAdFail: options?.onLoadAdFail,
      },
    );
  }, 3000)();
};
